/**
 * HUB-G — Liste timeline unifiée.
 */
import React from 'react';
import { Clock } from 'lucide-react';
import ActiviteTimelineCard from './ActiviteTimelineCard';

export default function ActiviteTimeline({
  events,
  loading,
  testIdPrefix = 'activite-timeline',
}) {
  if (loading) {
    return (
      <div className="flex justify-center py-12" data-testid={`${testIdPrefix}-loading`}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!events?.length) {
    return (
      <div
        className="text-center py-12 text-[var(--rm-gray-500)]"
        data-testid={`${testIdPrefix}-empty`}
      >
        <Clock className="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>Aucun événement pour cette période</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-list`}>
      {events.map((event) => (
        <div
          key={event.id}
          className="relative pl-4 border-l-2"
          style={{ borderColor: 'var(--rm-border-subtle)' }}
        >
          <div className="absolute -left-[5px] top-4 w-2 h-2 rounded-full bg-[var(--rm-gray-400)]" />
          <ActiviteTimelineCard event={event} testIdPrefix={testIdPrefix} />
        </div>
      ))}
    </div>
  );
}
